/* ログイン(お客様) */
import React, { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import Block from '../../molecules/Block';
import Text from '../../molecules/Text';
import Annotation from '../../atoms/Annotation';
import CenterButton from '../../atoms/CenterButton';
import axios from '../../axios';
import { handleBrowserBack } from '../../BrowserBack';
import LoadingModal from '../../molecules/LoadingModal';
import Popup from '../../molecules/Popup';

const ApplicantLogin: React.FC = () => {
  // ログイン情報のState
  const [password, setPassword] = useState('');
  const [login_id, setLoginId] = useState('');
  const [is_connecting, setIsConnecting] = useState(false);
  const [is_loading, setIsLoading] = useState(false);
  const [show_error_dialog, setShowErrorDialog] = useState(false);
  // Note sakuma ログインエラーメッセージとは別にstateを持つ
  const [token_mimatch_message, setTokenMimatchMessage] = useState('');

  // エラーメッセージ
  const [error_login_id, setErrorLoginId] = useState('');
  const [error_password, setErrorPassword] = useState('');

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
  }, []);

  // ログインボタンのクリックイベントを定義
  const handleClick = () => {
    // ログイン情報をStateへセット
    const login_info = { loginId: login_id, password: password };

    setErrorLoginId('');
    setErrorPassword('');

    const login = async () => {
      try {
        if (is_connecting) {
          return;
        }
        //ローディング画面表示
        setIsLoading(true);
        setIsConnecting(true);

        // ログイン処理
        await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/mypage/loginproc`, login_info);

        // ログイン成功
        // 案件一覧へ遷移
        location.href = `${location.origin}${process.env.MIX_MOCK_URL}/mypage/list`;
      } catch (error) {
        // エラー判定
        if (error.response.data.is_token_mismatch) {
          // トークン有効期限切れ
          setTokenMimatchMessage(error.response.data.message);
          setShowErrorDialog(error.response.data.is_token_mismatch);
        } else if (error.response.data.is_lockout_error) {
          // ロックアウト
          setErrorLoginId(error.response.data.message);
        } else {
          // エラーメッセージをセットする
          if (typeof error.response.data.message === 'object') {
            if (typeof error.response.data.message.loginId !== 'undefined') {
              // ログインIDエラー
              setErrorLoginId(error.response.data.message.loginId);
            }
            if (typeof error.response.data.message.password !== 'undefined') {
              // パスワードエラー
              setErrorPassword(error.response.data.message.password);
            }
          } else {
            if (
              typeof error.response.data.is_login !== 'undefined' &&
              !error.response.data.is_login
            ) {
              // ログイン失敗の場合、IDとパスワードにエラーメッセージを表示
              setErrorLoginId(error.response.data.message);
              setErrorPassword(error.response.data.message);
            } else {
              console.error(error.response.data.message);
              alert('システムエラーが発生しました');
            }
          }
        }
      } finally {
        setIsConnecting(false);
        //ローディング画面非表示
        setIsLoading(false);
      }
    };
    // ログイン処理
    login();
  };

  // パスワードリセット画面に遷移する
  const goPasswordReset = () => {
    location.replace(`${process.env.MIX_MOCK_URL}/applicant/password/reset`);
  };

  /**
   * モーダルを非表示にし、画面をリロードする
   */
  const reload = useCallback(() => {
    setIsLoading(false);
    setShowErrorDialog(true);
    location.reload();
  }, []);

  // 期限切れポップアップのボタン
  const popup_button = {
    label: '確認',
    variant: 'success',
    handleClick: reload,
  };

  return (
    <>
      <Block
        label="ログイン"
        content={
          <>
            <Annotation text="ご登録のメールアドレス (ログインID) とパスワードを入力のうえ、ログインして下さい。" />
            <div>
              <Text
                id="email"
                label="ログインID"
                value={login_id}
                placeholder=""
                handleChange={event => setLoginId(event.target.value)}
                disabled={false}
                maxlength={50}
                message={error_login_id}
                display_border={true}
              />
              <Text
                id="password"
                label="パスワード"
                type="password"
                value={password}
                placeholder=""
                handleChange={event => setPassword(event.target.value)}
                disabled={false}
                maxlength={256}
                message={error_password}
                display_border={true}
              />
            </div>
            <div className="p-link" onClick={() => goPasswordReset()}>
              パスワードを忘れた方はこちら
            </div>
            <div className="mt-4">
              マイページを新たに開設するお客様は、ブラウザを閉じて前の画面に戻り、
              <br />
              マイページ開設の手続にお進み下さい。
            </div>
          </>
        }
      />
      <CenterButton
        label="ログイン"
        handleClick={handleClick}
        btn_class="btn-green arrow-right mb-5"
      />
      {/* ローディング画面 */}
      <LoadingModal show={is_loading} />
      {/* 有効期限切れダイアログ */}
      <Popup
        title="有効期限切れ"
        text={token_mimatch_message}
        toggleShow={show_error_dialog}
        toggleClose={reload}
        first_button={popup_button}
      />
    </>
  );
};

if (document.getElementById('applicant-login')) {
  ReactDOM.render(<ApplicantLogin />, document.getElementById('applicant-login'));
}
